const companyActivationStrings = {
  companyActivationFilter: {
    searchBarPlaceholder: 'Company Name or Email',
  },

  companyActivationList: {
    companyActivationGridNoResultsFound: 'No results matching your search criteria',
    companyActivationGridHeader: {
      companyActivationProfileIdGridHeader: 'Profile ID',
      companyActivationNameGridHeader: 'Name',
      companyActivationEmailGridHeader: 'Email',
      companyActivationCompanyTypeGridHeader: 'Type',
      companyActivationIndustryGridHeader: 'Industry',
      companyActivationCountryGridHeader: 'Country',
      companyActivationContacGridHeader: 'Contact',
      companyActivationLicenceGridHeader: 'Licence',
      companyActivationActionsGridHeader: 'Actions',
    },
    companyActivationBrandProfileText: 'Brand Profile',
    copiedToClipboardText: 'Copied to clipboard 🚀',
    companyActivationGridVerifyActionBtn: 'Verify',
    companyActivationGridRejectActionBtn: 'Reject',
    actionPopupTitle(status) {
      return `Are you sure you want to mark this company as ${status} ?`;
    },
    actionPopupYesBtn: 'Yes',
    actionPopupNoBtn: 'No',
  },
};

export default companyActivationStrings;
